export const state = {
    total: 0,
    toExpire: 0,
    expiredNotClosed: 0,
    kitsPendingReception: 0,
    enabled: 0
}

export const getters = {
    total: state => state.toExpire + state.expiredNotClosed + state.kitsPendingReception,
    toExpire: state => state.toExpire,
    expiredNotClosed: state => state.expiredNotClosed,
    kitsPendingReception: state => state.kitsPendingReception,
    enabled: state => state.enabled
}
// mutations
export const mutations = {

    setToExpire (state, total) {
        state.toExpire = total
    },

    setExpiredNotClosed (state, total) {
        state.expiredNotClosed = total
    },
    setKitsPendingReception (state, total) {
        state.kitsPendingReception = total
    },

    setEnabled(state, enabled) {
        state.enabled = enabled
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/notifications.js